import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function URLTracker() {
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname + location.search;
    const isAuthPage = currentPath.startsWith('/login') ||
                      currentPath.startsWith('/auth') ||
                      currentPath.startsWith('/register') ||
                      currentPath.startsWith('/widget') ||
                      currentPath.startsWith('/communicator');

    // Save non-auth pages (except root) for potential redirect after login
    if (!isAuthPage && currentPath !== '/') {
      sessionStorage.setItem('prodgy_redirect_after_login', currentPath);
    }
  }, [location]);

  return null; // This component doesn't render anything
}
